/**
 * Created by eriksundqvist on 29/06/16.
 */
import React, {PropTypes} from 'react';

export class RemoveCoworkerButton extends React.Component {

  static propTypes = {
    coworkerId: PropTypes.number.isRequired,
    removeCoworker: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.removeCoworker = this.removeCoworker.bind(this);
  }

  removeCoworker () {
    this.props.removeCoworker(this.props.coworkerId);
  }

  render () {
    return (
      <button className='close' onClick={this.removeCoworker}></button>
    );
  }
}

export default RemoveCoworkerButton;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/remove-coworker-button.js
 **/